import { CaseData, CasePermissions, ApiResponse, HttpResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { primaryKey } from 'app/infrastructure/data/wireformat';
import { endpoint } from 'app/area/case/endpoints';
import { OptionsRequestParams } from 'app/infrastructure/ui/form/types';

export const api = {
  draft: async (id: number, includeFailedConstraints: boolean = false): Promise<HttpResponse<CaseData>> => {

    return new RemoteData(endpoint.draft).resource<HttpResponse<CaseData>>()
      .withId(id)
      .filter({ includeFailedConstraints })
      .response();
  },

  deleteDraft: async (caseDraftId: number, eTag: string) => {
    return new RemoteData(endpoint.draft)
      .resource<ApiResponse<CaseData>>()
      .withId(caseDraftId)
      .withIfMatch(eTag)
      .httpDelete(caseDraftId);
  },

  saveDraft: async (data: CaseData, eTag: string, includeFailedConstraints: boolean = false) => {

    return new RemoteData(endpoint.draft)
      .resource<HttpResponse<CaseData>>()
      .withId(primaryKey(data))
      .withIfMatch(eTag)
      .filter({ includeFailedConstraints })
      .save(data);
  },
  
  permissions: async (caseNumber: number): Promise<CasePermissions[]> => {
    
        const response = await new RemoteData(endpoint.casePermissions).resource<ApiResponse<CasePermissions[]>>()
          .filter({ caseId: caseNumber })
          .single();
    
        return response.data;
  },

  options: async (transNo: number, domainId: number, params: OptionsRequestParams, search: boolean) => {
    return new RemoteData(`case/draft/${transNo}/field/${domainId}/options${search ? '/search' : ''}`).resource()
      .filter({
        ...params,
        ...{
          businessType: 1 //This will be part of case metadata in the future.
        }
      }).all();
  },

  categoryOptions: async (transNo: number, domainId: number, params: OptionsRequestParams, search: boolean) => {
    return new RemoteData(`case/draft/${transNo}/field/${domainId}/categoryOptions${search ? '/search' : ''}`).resource()
      .filter({
        ...params,
        ...{
          businessType: 1 //This will be part of case metadata in the future.
        }
      }).all();
  },

  submitCase: async (parameters) => {
    const response: any = await new RemoteData(endpoint.case).resource<ApiResponse<CaseData>>()
    .filter(parameters)
    .create(undefined, false);

    const json = await response.json();

    return json.data.caseId;
  }
  
};
